import { match, propOr, path, equals } from 'ramda';
import { UNAUTHORIZED } from 'http-status';
import { logOut } from './actions';

const authMiddleware = ({ getState }) => next => action => {
  const { type, payload } = action;

  if (type && type !== 'AUTH_REQUEST_ERROR' && match(/_ERROR/g, type).length > 0) {
    const status = propOr(path(['response', 'status'], payload), 'status', payload);

    // Unauthorized means we need to logout
    if (equals(UNAUTHORIZED, status)) {
      logOut()(next, getState);
    }
  }

  next(action);
};

export default authMiddleware;
